import React from 'react';
import styles from './YourTownloopProductList.module.scss';

interface YourTownloopSuggestListProps {
  products: any[];
  getId?: (id: string) => void;
}

const YourTownloopSuggestList: React.FC<YourTownloopSuggestListProps> = ({ products, getId }) => {

  return (
    <div className={styles['products-block']}>
      <div className={styles['orders-products-list']}>
        {products.slice(0, 5).map((product, idx) => {
          if (!product) return null;
          
          return (
            <div className={styles['product-item']} key={idx} onClick={() => getId && getId(product?.product_id)}>
              <img 
                className={styles['product-img']} 
                src={product?.product_media_list?.[0]?.product_media_file_url || ''}  
                alt={product?.product_title || 'Product'}
              />
              <div
                className={`${styles['product-title']} overflowText`}
                title={product?.product_title}
              >
                {product?.product_title}
              </div>
              <div className={styles['product-prices']}>
                <div className={styles['product-prices-subbox']}>
                  <span className={styles['product-price']}>
                    ${product?.product_sku_values?.[0]?.product_price || ''}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YourTownloopSuggestList;
